<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem; margin-bottom: 0!important;">
		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" icon="el-icon-search">查询</el-button>
			<el-button type="primary" size="mini" @click="openModel('kpjl')" icon="el-icon-plus">添加</el-button>
		</div>
		<div>
			<el-table
				:data="kpjlList"
				style="width: 100%"
				size="mini"
				row-key="id"
				:tree-props="{ children: 'child', hasChildren: 'hasChildren' }"
				@current-change="handleCurrentChange"
			>
				<el-table-column width="80" align="center">
					<template slot="header" slot-scope="scope">
						编号
					</template>
					<template slot-scope="scope">
						{{ scope.row.id }}
					</template>
				</el-table-column>
				<el-table-column width="100">
					<template slot="header" slot-scope="scope">
						发票号
					</template>
					<template slot-scope="scope">
						{{ scope.row.fph }}
					</template>
				</el-table-column>
				<el-table-column width="180">
					<template slot="header" slot-scope="scope">
						公司全称
					</template>
					<template slot-scope="scope">
						{{ scope.row.mc }}
					</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">
						纳税号
					</template>
					<template slot-scope="scope">
						{{ scope.row.nsh }}
					</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">
						开票金额
					</template>
					<template slot-scope="scope">
						{{ scope.row.kpje }}
					</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">
						开票状态
					</template>
					<template slot-scope="scope">
						<el-button type="info" v-if="scope.row.kpzt == 0" plain size="mini">未开票</el-button>
						<el-button type="success" v-else-if="scope.row.kpzt == 1" plain size="mini">已开票</el-button>
						<el-button type="warning" v-else plain size="mini">已作废</el-button>
					</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">
						创建人
					</template>
					<template slot-scope="scope">
						{{ scope.row.cjr.name }}
					</template>
				</el-table-column>
				<el-table-column align="center" label="创建时间" width="130">
					<template slot-scope="scope">
						{{ scope.row.create_time.slice(0, 10) }}
					</template>
				</el-table-column>
				<el-table-column align="center" fixed="right" width="200">
					<template slot="header" slot-scope="scope">
						操作
					</template>
					<template slot-scope="scope">
						<!-- <el-button type="primary" size="mini" @click="openModel('kpjl',scope.row)">查看</el-button> -->
						<el-button type="primary" size="mini" @click="openModel('kpjl', scope.row)">编辑</el-button>
						<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
		<el-dialog title="编辑信息" :visible.sync="createModel" top="10vh">
			<!-- 表单内容 -->
			<div class="d-flex mt-2">
				<div style="width: 33%">
					<el-form v-if="preUrl === 'kpjl'" ref="form" :model="form.kpjl" label-width="80px">
						<el-form-item label="发票号"><el-input v-model="form.kpjl.fph" size="mini" style="width: 95%;" :disabled="true"></el-input></el-form-item>
						<el-form-item label="开户行"><el-input v-model="form.kpjl.khh" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="座机"><el-input v-model="form.kpjl.zj" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="开票金额"><el-input-number v-model="form.kpjl.kpje" @change="handleChange" size="mini"></el-input-number></el-form-item>
						<el-form-item label="上传图片">
							<div>
								<span v-if="!kppz" class="btn btn-light border mr-2" @click="chooseImage"><i class="el-icon-upload"></i></span>
								<img v-else :src="kppz" class="rounded" style="width: 45px;height: 45px;cursor: pointer;" @click="chooseImage" />
							</div>
						</el-form-item>
					</el-form>
				</div>
				<div style="width: 33%">
					<el-form v-if="preUrl === 'kpjl'" ref="form" :model="form.kpjl" label-width="80px">
						<el-form-item label="* 公司全称"><el-input v-model="form.kpjl.mc" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="开户账号"><el-input v-model="form.kpjl.khzh" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="邮寄地址"><el-input v-model="form.kpjl.yjdz" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="开票状态">
							<el-select v-model="form.kpjl.kpzt" placeholder="请选择" size="mini">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="关联订单">
							<el-select v-model="form.kpjl.gldd" placeholder="请选择" size="mini">
								<el-option v-for="item in xxdd" :key="item.id" :label="item.ddh" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
				<div style="width: 33%">
					<el-form v-if="preUrl === 'kpjl'" ref="form" :model="form.kpjl" label-width="80px">
						<el-form-item label="纳税号"><el-input v-model="form.kpjl.nsh" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="公司地址"><el-input v-model="form.kpjl.gsdz" size="mini" style="width: 95%;"></el-input></el-form-item>
					</el-form>
				</div>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				kpjl: {}
			},
			createModel: false,
			value: '',
			xxdd: [],
			dialogType: 'kpjl',
			preUrl: 'kpjl', //api
			dialogId: 0,
			kpjlList: [],
			kppz: '',
			options: [
				{
					value: 0,
					label: '未开票'
				},
				{
					value: 1,
					label: '已开票'
				},
				{
					value: 2,
					label: '已作废'
				}
			]
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	created() {
		this.axios.get('/admin/xxdds', { token: true }).then(res => {
			this.xxdd = res.data.data;
		});
	},
	methods: {
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`;
		},
		// 处理列表结果
		getListResult(e) {
			this.kpjlList = e.list;
		},
		openModel(type, item = false) {
			// 初始化表单
			switch (type) {
				// 初始化添加管理员
				case 'kpjl':
					if (!item) {
						this.form.kpjl = {
							id: '',
							fph: '自动生成',
							mc: '',
							nsh: '',
							khh: '',
							khzh: '',
							gsdz: '',
							zj: '',
							yjdz: '',
							gldd: '',
							kpje: 0,
							kpzt: 0,
							kppz: ''
						};
						this.dialogId = 0;
					} else {
						this.form.kpjl = {
							id: item.id,
							fph: item.fph,
							mc: item.mc,
							nsh: item.nsh,
							khh: item.khh,
							khzh: item.khzh,
							gsdz: item.gsdz,
							zj: item.zj,
							yjdz: item.yjdz,
							gldd: item.gldd,
							kpje: item.kpje,
							kpzt: item.kpzt,
							kppz: item.kppz,
							khid: item.khid,
							cjr: item.cjr.name
						};
						this.dialogId = item.id;
					}
					break;
			}
			// 打开dialog
			this.createModel = true;
		},
		chooseImage() {
			this.app.chooseImage(res => {
				this.xsxsdata.sctp = res[0].url;
			}, 1);
		},
		submit() {
			let f = this.form.kpjl;
			let e = {
				id: f.id,
				fph: f.fph,
				mc: f.mc,
				nsh: f.nsh,
				khh: f.khh,
				khzh: f.khzh,
				gsdz: f.gsdz,
				zj: f.zj,
				yjdz: f.yjdz,
				gldd: f.gldd,
				kpje: f.kpje,
				kpzt: f.kpzt,
				kppz: this.kppz,
				khid: f.khid,
				cjr: this.user.id
			};
			this.addOrEdit(e, this.dialogId);
			this.createModel = false;
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		},
		handleChange(value) {
			console.log(value);
		}
	}
};
</script>

<style></style>
